import type { QueryFunctionContext } from '@tanstack/react-query';

import queryStringify from '../url/query-stringify';
import { API_BASE_PATH } from 'constants/new-configs';

import http from './http';

/**
 * @function fetcherQuery
 * @param options
 */
const fetcherQuery = async (options: QueryFunctionContext) => {
  const { queryKey = [], meta = {} } = options;

  const token = meta.token as string | undefined;
  const basePath = meta.basePath as string | undefined;
  const baseURL = meta.baseUrl as string | undefined;

  const [rpath, rparams] = queryKey;
  const path = rpath ? `${basePath || API_BASE_PATH}/${rpath}` : '';
  const params = rparams ? (rparams as Record<string, unknown>) : {};
  const pstring = queryStringify(params);

  const response = await http({
    path,
    params: pstring,
    token,
    baseURL,
  });
  return Promise.resolve(response);
};

export default fetcherQuery;
